import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const GRIS_BLOQUEADO = "rgba(158, 158, 158, 0.08)";

// Botón toggle de una marca de la línea (hoy "Promo / Seña").
// - activo: la línea tiene la marca.
// - bloqueado: la marca no se puede aplicar (tooltips.bloqueado explica por qué).
export default function BotonMarcaLinea({
  label,
  activo,
  bloqueado,
  tooltips,
  color,
  IconoActivo,
  IconoInactivo,
  onToggle,
  ancho = "48px",
}) {
  const tooltip = bloqueado
    ? tooltips.bloqueado
    : activo
      ? tooltips.activo
      : tooltips.inactivo;

  return (
    <Tooltip title={tooltip} arrow>
      <Box
        onClick={(e) => {
          e.stopPropagation();
          if (!bloqueado) {
            onToggle(!activo);
          }
        }}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          cursor: bloqueado ? "not-allowed" : "pointer",
          p: 1.5,
          borderRadius: "6px",
          width: ancho,
          height: "25px",
          backgroundColor: activo
            ? `rgba(${color.rgb}, 0.12)`
            : bloqueado
              ? GRIS_BLOQUEADO
              : "white",
          border: "2px solid",
          borderColor: activo ? color.main : bloqueado ? "grey.400" : "#e0e0e0",
          boxShadow: activo
            ? `0 2px 4px rgba(${color.rgb}, 0.2)`
            : "0 1px 2px rgba(0,0,0,0.05)",
          opacity: bloqueado ? 0.6 : 1,
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          "&:hover": {
            backgroundColor: bloqueado
              ? GRIS_BLOQUEADO
              : activo
                ? `rgba(${color.rgb}, 0.18)`
                : "rgba(0, 0, 0, 0.02)",
            borderColor: bloqueado ? "grey.400" : activo ? color.dark : color.hoverBorder,
            boxShadow: bloqueado ? "0 1px 2px rgba(0,0,0,0.05)" : "0 4px 8px rgba(0,0,0,0.1)",
            transform: bloqueado ? "none" : "translateY(-2px)",
          },
          "&:active": {
            transform: "translateY(0)",
            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
          },
        }}
      >
        {activo ? (
          <IconoActivo sx={{ fontSize: 22, color: color.main }} />
        ) : (
          <IconoInactivo
            sx={{ fontSize: 22, color: bloqueado ? "grey.500" : "text.secondary" }}
          />
        )}
        <Typography
          variant="caption"
          sx={{
            mt: 0.5,
            color: activo ? color.main : bloqueado ? "grey.600" : "text.secondary",
            fontWeight: activo ? 700 : 500,
            fontSize: "0.7rem",
            whiteSpace: "nowrap",
            lineHeight: 1,
          }}
        >
          {label}
        </Typography>
      </Box>
    </Tooltip>
  );
}
